import { Box, Button, Flex, Stack, Text } from "@mantine/core";
import { openConfirmModal, openContextModal } from "@mantine/modals";
import axios from "axios";
import { useState } from "react";
import variables from "../../../styles/variables.module.scss";
import { InputTextProps } from "../components/inputText";
import { FormGroup } from "./formGroup";
import { api } from "@/services/services";
import { generateToken } from "services/otplibServices";

export function NewDynamicForm(props: {
  label: string;
  description: string;
  controls: {
    label: string;
    description: string;
    controls: InputTextProps[];
    cols: number;
    name: string;
  };
  submit?: {
    label: string;
    uri: string;
    method: string;
  };
  afterSubmit?: {
    title: string;
  };
  confirmSubmit?: {
    title: string;
    description: string;
    labelConfirm: string;
    labelCancel: string;
  };
}) {
  const [value, setValue] = useState<{ [k: string]: any }>({});
  const [hasError, setHasError] = useState<boolean>(true);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const submit = async () => {
    if (hasError) return;
    if (props.confirmSubmit) {
      openConfirmModal({
        title: props.confirmSubmit?.title,
        children: <Text size="sm">{props.confirmSubmit?.description}</Text>,
        labels: {
          confirm: props.confirmSubmit?.labelConfirm,
          cancel: props.confirmSubmit?.labelCancel,
        },
        onConfirm: realSubmit,
        onCancel: () => {},
      });
    } else {
      await realSubmit();
    }
  };

  const realSubmit = async () => {
    // const hostNameUrl = window.location.hostname;
    // const actualHostName =
    //   hostNameUrl !== undefined &&
    //   hostNameUrl !== "" &&
    //   !hostNameUrl.includes("localhost")
    //     ? `https://${hostNameUrl}/api`
    //     : process.env.NEXT_PUBLIC_API_URL;
    setIsSubmitted(false);
    const hostNameUrl = window.location.hostname;
    const actualHostName = api() ?? `https://${hostNameUrl}/api`;
    console.log("marketing email api url", actualHostName);
    if (props.submit?.method === "POST") {
      const res = await axios.post(
        `${actualHostName}/${props.submit?.uri}`,
        value,
        {
          headers: {
            "x-dynamic-token": generateToken(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        openContextModal({
          modal: "success",
          centered: true,
          innerProps: {
            text: props.afterSubmit?.title,
            color: variables.primaryColor,
          },
        });
        setValue({});
      }
    }
    setIsSubmitted(true);
  };
  return (
    <Stack
      spacing="md"
      style={{
        backgroundImage: "url(/images/subscribe-mail.png)",
        backgroundSize: "cover",
        margin: 40,
        borderRadius: 48,
      }}
      sx={(theme) => ({
        [theme.fn.largerThan("md")]: { padding: 48 },
        [theme.fn.smallerThan("md")]: { padding: 30 },
      })}
    >
      <Box
        style={{
          backgroundColor: "#FFFFFF7A",
          borderRadius: 24,
          border: "2px solid #ffffff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
        }}
        sx={(theme) => ({
          [theme.fn.largerThan("md")]: { padding: 40 },
          [theme.fn.smallerThan("md")]: { padding: 30 },
        })}
      >
        <div>
          <Flex align="center" justify="center">
            <Text style={{ fontSize: 32, textAlign: "center" }} fw={700}>
              {props.label}
            </Text>
          </Flex>
          <Flex align="center" justify="center">
            <Text style={{ textAlign: "center" }}>{props.description}</Text>
          </Flex>
        </div>
        <div style={{ width: "100%" }}>
          <FormGroup
            label={props.controls.label}
            description={props.controls.description}
            controls={props.controls.controls}
            cols={props.controls.cols}
            name={props.controls.name}
            value={value}
            isSubmitted={isSubmitted}
            onChange={(v) => {
              setValue(v);
            }}
            hasError={(e) => {
              setHasError(e);
            }}
          ></FormGroup>
        </div>
        <Button
          style={{ width: 160 }}
          radius={32}
          onClick={submit}
          disabled={hasError}
        >
          {props.submit?.label}
        </Button>
      </Box>
    </Stack>
  );
}
